import React from 'react';

import { Flex, Select, TextInput } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form/lib/types';
import { useTranslation } from 'react-i18next';
import { UserAccess } from 'shared/interfaces/User';

interface InviteUserFormValues {
  email: string;
  firstName: string;
  lastName: string;
  role: string;
}

interface InviteUserFormProps {
  form: UseFormReturnType<InviteUserFormValues>;
}

export function InviteUserForm({ form }: InviteUserFormProps) {
  const { t } = useTranslation();

  return (
    <form
      style={{
        width: '100%'
      }}>
      <Flex direction="row" align="start" justify="space-between" gap="lg">
        <TextInput
          label={t('INVITE_USER.EMAIL')}
          withAsterisk
          placeholder={t('INVITE_USER.EMAIL_PH')}
          {...form.getInputProps('email')}
        />
        <TextInput
          label={t('INVITE_USER.FIRST_NAME')}
          withAsterisk
          placeholder={t('INVITE_USER.FIRST_NAME_PH')}
          {...form.getInputProps('firstName')}
        />
        <TextInput
          label={t('INVITE_USER.LAST_NAME')}
          withAsterisk
          placeholder={t('INVITE_USER.LAST_NAME_PH')}
          {...form.getInputProps('lastName')}
        />
        <Select
          label={t('INVITE_USER.USER_ACCESS')}
          data={[
            { value: UserAccess.MEMBER.toString(), label: t('USER_ACCESS.MEMBER') },
            { value: UserAccess.ADMIN.toString(), label: t('USER_ACCESS.ADMIN') }
          ]}
          withAsterisk
          placeholder={t('INVITE_USER.ACCESS_TYPE')}
          {...form.getInputProps('role')}
        />
      </Flex>
    </form>
  );
}
